import * as React from 'react'

import { Box, CheckBox, Table } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { getColumnsColspan } from 'modules/attendance/components/TimeTracking/Content/_Table/tableColSpans'

export interface SelectEmployeeProps {
  rowSelected: boolean
  canUpdateUser: boolean
  rowDisabled: boolean
}

const SelectEmployee = ({ rowSelected, canUpdateUser, rowDisabled }: SelectEmployeeProps) => {
  const COLSPANS = getColumnsColspan()

  return (
    <Table.Cell colSpan={COLSPANS.SELECT_ALL_COLUMN} wide>
      <Box flexDirection="row" alignItems="center">
        {canUpdateUser && <CheckBox checked={rowSelected} disabled={rowDisabled} />}
      </Box>
    </Table.Cell>
  )
}

export default observer(SelectEmployee)
